import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-white">
      <div className="flex flex-col items-center space-y-6">
        <img
          src="/assets/loading.gif"
          alt="Chargement..."
          className="w-40 h-40"
        />
        <p className="text-2xl text-gray-700 font-semibold text-center">
          Chargement des données...
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
